import { render, staticRenderFns } from "./CompanyPanel.vue?vue&type=template&id=7c5b27a6&scoped=true&"
import script from "./CompanyPanel.vue?vue&type=script&lang=js&"
export * from "./CompanyPanel.vue?vue&type=script&lang=js&"
import style0 from "./CompanyPanel.vue?vue&type=style&index=0&id=7c5b27a6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5b27a6",
  null
  
)

export default component.exports